import React from 'react';
import { Play, Pause, Trash2, Plus, Send, Zap } from 'lucide-react';
import { StatusBadge } from './shared';

export function CampaignsTab({ campaigns, segments, onAdd, onStatusChange, onStartCampaign, onDelete }) {
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <p className="text-gray-400">{campaigns.length} campanha(s)</p>
        <button
          onClick={onAdd}
          className="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors"
        >
          <Plus size={18} />
          Nova Campanha
        </button>
      </div>

      <div className="grid gap-4">
        {campaigns.map(campaign => (
          <div
            key={campaign.id}
            className="bg-gray-800/50 rounded-xl p-5 border border-gray-700/50"
          >
            <div className="flex items-start justify-between">
              <div className="flex-1 min-w-0">
                <h3 className="text-lg font-semibold text-white flex items-center gap-2">
                  <Send size={18} className="text-purple-400 flex-shrink-0" />
                  <span className="truncate">{campaign.name}</span>
                  <StatusBadge status={campaign.status} />
                </h3>
                {campaign.description && (
                  <p className="text-gray-400 text-sm mt-1">{campaign.description}</p>
                )}
                
                <div className="flex flex-wrap gap-x-6 gap-y-1 mt-4 text-sm">
                  <div>
                    <span className="text-gray-500">Total de Leads:</span>
                    <span className="text-white ml-2">{campaign.total_leads}</span>
                  </div>
                  <div>
                    <span className="text-gray-500">Contatados:</span>
                    <span className="text-blue-400 ml-2">{campaign.contacted}</span>
                  </div>
                  <div>
                    <span className="text-gray-500">Convertidos:</span>
                    <span className="text-green-400 ml-2">{campaign.converted}</span>
                  </div>
                  <div>
                    <span className="text-gray-500">Msgs:</span>
                    <span className={`ml-2 ${(campaign.opening_messages || []).length > 0 ? 'text-green-400' : 'text-red-400'}`}>
                      {(campaign.opening_messages || []).length} abertura
                    </span>
                    {(campaign.followup_messages || []).length > 0 && (
                      <span className="text-blue-400 ml-1">+ {(campaign.followup_messages || []).length} follow-up</span>
                    )}
                  </div>
                </div>
              </div>

              <div className="flex gap-2 flex-shrink-0 ml-3">
                {campaign.status === 'draft' && onStartCampaign && (
                  <button
                    onClick={() => onStartCampaign(campaign.id)}
                    className="flex items-center gap-1 px-3 py-2 bg-blue-500/20 hover:bg-blue-500/30 text-blue-400 rounded-lg"
                    data-testid={`campaign-start-${campaign.id}`}
                  >
                    <Zap size={16} />
                    Iniciar
                  </button>
                )}
                {campaign.status === 'active' ? (
                  <button
                    onClick={() => onStatusChange(campaign.id, 'paused')}
                    className="flex items-center gap-1 px-3 py-2 bg-yellow-500/20 hover:bg-yellow-500/30 text-yellow-400 rounded-lg"
                  >
                    <Pause size={16} />
                    Pausar
                  </button>
                ) : campaign.status !== 'completed' && campaign.status !== 'draft' && (
                  <button
                    onClick={() => onStatusChange(campaign.id, 'active')}
                    className="flex items-center gap-1 px-3 py-2 bg-green-500/20 hover:bg-green-500/30 text-green-400 rounded-lg"
                  >
                    <Play size={16} />
                    Retomar
                  </button>
                )}
                {onDelete && (
                  <button
                    onClick={() => onDelete(campaign.id, campaign.name)}
                    className="flex items-center gap-1 px-3 py-2 bg-red-500/20 hover:bg-red-500/30 text-red-400 rounded-lg"
                    title="Excluir campanha"
                    data-testid={`campaign-delete-${campaign.id}`}
                  >
                    <Trash2 size={16} />
                  </button>
                )}
              </div>
            </div>
          </div>
        ))}

        {campaigns.length === 0 && (
          <div className="text-center py-10 text-gray-500">
            <Send size={48} className="mx-auto mb-3 opacity-50" />
            <p>Nenhuma campanha criada</p>
          </div>
        )}
      </div>
    </div>
  );
}

// ==================== TAB DE PILOTO AUTOMÁTICO (SCHEDULER) ====================
